import { Injectable } from '@angular/core';

declare const InstallTrigger: any;

@Injectable({
  providedIn: 'root'
})
export class BrowserDetectionService {

  constructor() {
  }

  // Opera 8.0+
  public isOpera = (!!window['opr'] && !!window['opr'].addons) || !!window['opera'] || navigator.userAgent.indexOf(' OPR/') >= 0;

  // Firefox 1.0+
  public isFirefox = typeof InstallTrigger !== 'undefined';

  // Safari 3.0+ "[object HTMLElementConstructor]"
  public isSafari = /constructor/i.test(window['HTMLElement'] as any) || (function (p) {
    return p.toString() === '[object SafariRemoteNotification]';
  })(!window['safari'] || (typeof window['safari'] !== 'undefined' && window['safari'].pushNotification));

  // Internet Explorer 6-11
  public isIE = /*@cc_on!@*/false || !!document['documentMode'];

  // Edge 20+
  public isEdge = !this.isIE && !!window['StyleMedia'];

  // Chrome 1+
  public isChrome = !!window['chrome'] && !!window['chrome'].webstore;

  // Blink engine detection
  public isBlink = (this.isChrome || this.isOpera) && !!window['CSS'];
}
